import Typology from "./Typology";

export default Typology;
